import React, { useEffect } from "react";

/* ─── SPARKS (background) ────────────────────────────────────── */
const SPARK_COLOURS = ["#ffd700","#ff2d78","#00e5ff","#bf5fff","#ffffff"];
export function Sparks() {
  const sparks = Array.from({ length: 18 }, (_, i) => {
    const size = Math.random() * 4 + 2;
    const col  = SPARK_COLOURS[Math.floor(Math.random() * SPARK_COLOURS.length)];
    return (
      <div key={i} className="spark" style={{
        left: `${Math.random() * 100}%`,
        bottom: `-${size * 2}px`,
        width: size, height: size,
        background: col, boxShadow: `0 0 ${size * 2}px ${col}`,
        animationDuration: `${Math.random() * 10 + 8}s`,
        animationDelay: `${Math.random() * 12}s`,
      }} />
    );
  });
  return <div className="sparks-container">{sparks}</div>;
}

/* ─── CONFETTI ───────────────────────────────────────────────── */
const CONFETTI_COLOURS = ["#ffd700","#ff2d78","#00e5ff","#bf5fff","#4caf50","#ff9800"];
export function Confetti() {
  const pieces = Array.from({ length: 60 }, (_, i) => {
    const col   = CONFETTI_COLOURS[i % CONFETTI_COLOURS.length];
    const size  = Math.random() * 8 + 5;
    const left  = Math.random() * 100;
    const delay = Math.random() * 0.8;
    const dur   = Math.random() * 1.5 + 2;
    return (
      <div key={i} className="confetti-piece" style={{
        left: `${left}%`, width: size, height: size * 0.6,
        background: col, animationDelay: `${delay}s`, animationDuration: `${dur}s`,
        borderRadius: Math.random() > 0.5 ? "50%" : 2,
        transform: `rotate(${Math.random() * 360}deg)`,
      }} />
    );
  });
  return <div className="confetti-container">{pieces}</div>;
}

/* ─── TOAST ──────────────────────────────────────────────────── */
export function Toast({ messages, onDone }) {
  useEffect(() => {
    if (!messages.length) return;
    const t = setTimeout(onDone, 2800);
    return () => clearTimeout(t);
  }, [messages, onDone]);
  if (!messages.length) return null;
  return (
    <div className="toast-stack">
      {messages.map((m, i) => <div key={i} className="toast">{m}</div>)}
    </div>
  );
}
